var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"primary-button",attrs:{"block":"","color":"primary","disabled":_vm.disabled,"elevation":"0","sls-element-id":_vm.slsElementId},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }